import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

// Contexto de la aseguradora seleccionada en la sesión actual (código de
// aseguradora de la póliza elegida por el cliente). Existe para que
// componentes ajenos al flujo de pólizas (ej. Footer.js) puedan REACCIONAR
// cuando esa aseguradora cambia — login, selección de póliza, logout — en
// vez de leer sessionStorage una sola vez de forma imperativa y quedar
// desactualizados para siempre.
//
// Este proyecto no tiene hoy ningún punto que fije "codigoAseguradora" en
// sessionStorage (ese flujo vive en miseguro_front/src/general.js); este
// contexto queda preparado para que, si algún día se agrega esa selección
// aquí, baste con llamar a establecerCodigoAseguradora() y Footer.js ya
// reaccione solo — igual que en miseguro_front.

const CLAVE_SESSION_STORAGE = "codigoAseguradora";

const AseguradoraContext = createContext({
  codigoAseguradora: null,
  establecerCodigoAseguradora: () => {},
});

export function AseguradoraProvider({ children }) {
  const [codigoAseguradora, setCodigoAseguradora] = useState(null);

  // Se lee en un efecto (no como estado inicial) para garantizar que corre
  // DESPUÉS de cualquier limpieza de sessionStorage al montar la app — así
  // el valor inicial siempre refleja lo que realmente quedó en
  // sessionStorage, nunca un valor "fantasma" de la sesión anterior.
  useEffect(() => {
    const valorActual = sessionStorage.getItem(CLAVE_SESSION_STORAGE);
    if (valorActual) {
      setCodigoAseguradora(valorActual);
    }
  }, []);

  const establecerCodigoAseguradora = useCallback((codigo) => {
    if (codigo) {
      sessionStorage.setItem(CLAVE_SESSION_STORAGE, codigo);
    } else {
      sessionStorage.removeItem(CLAVE_SESSION_STORAGE);
    }
    setCodigoAseguradora(codigo || null);
  }, []);

  return (
    <AseguradoraContext.Provider value={{ codigoAseguradora, establecerCodigoAseguradora }}>
      {children}
    </AseguradoraContext.Provider>
  );
}

export function useAseguradora() {
  return useContext(AseguradoraContext);
}

export default AseguradoraContext;
